import { Controller } from "@hotwired/stimulus"

// Disables the "days of inactivity" field when auto-resolution is switched off,
// since the value is meaningless until it's enabled.
export default class extends Controller {
  static targets = ["enabled", "days", "daysRow"]

  connect() {
    this.toggleDays()
  }

  toggleDays() {
    const enabled = this.enabledTarget.checked
    this.daysTarget.disabled = !enabled
    if (this.hasDaysRowTarget) {
      this.daysRowTarget.classList.toggle("opacity-50", !enabled)
    }
  }
}
